  import React, { useState, useEffect } from "react";
  import { Link } from "react-router-dom";
  import { FaUserFriends, FaImages, FaInfoCircle, FaPaperPlane, FaThumbsUp, FaCommentAlt } from "react-icons/fa";
  import Photos from "./Photos";
import About from "./About";

  const Profile = () => {
    const [activeTab, setActiveTab] = useState("Mur perso");
    const [user, setUser] = useState({ firstName: "Loading...", lastName: "", email: "", familyId: "" });    const [newPost, setNewPost] = useState("");
    const [posts, setPosts] = useState([]);
    const [activeMenu, setActiveMenu] = useState(null);

    const [newComment, setNewComment] = useState("");
const [postIdForComment, setPostIdForComment] = useState(null);
const [activeCommentMenu, setActiveCommentMenu] = useState(null);

    const API_URL = "https://api.lii.com.co:5101";

    const generateAvatarUrl = (name) => `https://api.dicebear.com/6.x/personas/svg?seed=${encodeURIComponent(name)}`;

    useEffect(() => {
      const fetchUser = async () => {
        try {
          const storedUser = JSON.parse(localStorage.getItem("user"));
          if (storedUser) {
            setUser(storedUser); // ✅ Inclut l'email
          } else {
            const token = localStorage.getItem("token");
            const response = await fetch(`${API_URL}/api/auth/me`, {
              headers: { Authorization: `Bearer ${token}` },
            });
            if (response.ok) {
              const data = await response.json();
              setUser(data);
              localStorage.setItem("user", JSON.stringify(data)); // ✅ Stocke aussi l'email
            }
          }
        } catch (error) {
          console.error("Error fetching user:", error);
        }
      };
      fetchUser();
    }, []);

    useEffect(() => {
      const fetchProfilePosts = async () => {
        try {
          const storedUser = JSON.parse(localStorage.getItem("user"));
          if (storedUser?._id) {
            const response = await fetch(`${API_URL}/api/posts/profile/${storedUser._id}`, {
              headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
            });            if (response.ok) {
              const data = await response.json();
              setPosts(data); // ✅ Displays only profile posts
            } else {
              console.error("Failed to fetch profile posts", response.status);
            }
          }
        } catch (error) {
          console.error("Error fetching profile posts:", error);
        }
      };
      fetchProfilePosts();
    }, []);

    const handlePost = async () => {
      console.log("📩 handlePost triggered"); // ✅ Ajoute ce log
    
      if (!newPost.trim()) {
        console.log("⚠️ Post vide, non envoyé");
        return;
      }
    
      try {
        const storedUser = JSON.parse(localStorage.getItem("user"));
        const token = localStorage.getItem("token");
        console.log("👤 Utilisateur:", storedUser);
        console.log("🔑 Token:", token);
    
        if (!storedUser || !storedUser._id || !token) {
          console.error("❌ User or token missing");
          alert("Votre session a expiré. Veuillez vous reconnecter.");
          localStorage.removeItem("token");
          localStorage.removeItem("user");
          window.location.href = "/login";
          return;
        }
    
        const postData = { text: newPost };
    
        const response = await fetch(`${API_URL}/api/posts/profile/${storedUser._id}`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json", 
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(postData),
        });
    
        console.log("📡 Requête envoyée...");
    
        if (response.status === 401) {
          console.warn("🔴 Token expiré ou invalide !");
          alert("Votre session a expiré. Veuillez vous reconnecter.");
          localStorage.removeItem("token");
          localStorage.removeItem("user");
          window.location.href = "/login";
          return;
        }
    
        if (!response.ok) {
          const errorData = await response.json();
          console.error(`❌ Échec création post – ${response.status}: ${errorData.message}`);
          return;
        }
    
        const data = await response.json();
        console.log("✅ Post créé :", data);
        setPosts([data, ...posts]);
        setNewPost("");
      } catch (error) {
        console.error("❌ Erreur lors du post :", error);
      }
    };
    const handleLikePost = async (postId) => {
      try {
        const storedUser = JSON.parse(localStorage.getItem("user"));
        const token = localStorage.getItem("token");

        const response = await fetch(`${API_URL}/api/posts/${postId}/like`, {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ user: storedUser?._id }),
        });

        if (response.ok) {
          const updatedPost = await response.json();
          setPosts((prev) =>
            prev.map((p) => (p._id === updatedPost._id ? updatedPost : p))
          );
        }
      } catch (error) {
        console.error("Error liking profile post:", error);
      }
    };


    const handleDeleteComment = async (postId, commentId) => {
  console.log(`🗑️ Tentative de suppression du commentaire ${commentId} sur le post ${postId}`);

  try {
    const url = `${API_URL}/api/posts/profile/${postId}/comment/${commentId}`;
    console.log(`🔍 Envoi de la requête DELETE à : ${url}`);

    const response = await fetch(url, { 
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    });

    console.log("📡 Réponse reçue :", response);

    if (!response.ok) {
      const errorData = await response.json();
      console.error(`❌ Erreur API (${response.status}) : ${errorData.message}`);
      console.log("🛠️ Vérifie que postId et commentId sont corrects.");
      return;
    }

    console.log(`✅ Commentaire ${commentId} supprimé avec succès`);

    // Mettre à jour l'UI après suppression
    setPosts((prevPosts) =>
      prevPosts.map(post =>
        post._id === postId
          ? { ...post, comments: post.comments.filter(comment => comment._id !== commentId) }
          : post
      )
    );
    setActiveCommentMenu(null);
  } catch (error) {
    console.error("❌ Erreur dans handleDeleteComment :", error.message);
  }
};


    const handleAddComment = async (postId) => {
      if (!newComment.trim()) return;
    
      try {
        const storedUser = JSON.parse(localStorage.getItem("user"));
        const token = localStorage.getItem("token");
    
        const response = await fetch(`${API_URL}/api/posts/profile/${postId}/comment`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ comment: newComment, author: storedUser?._id }),
        });
    
        if (!response.ok) throw new Error("Erreur lors de l'ajout du commentaire");
    
        const updatedPost = await response.json();
    
        setPosts((prevPosts) =>
          prevPosts.map((post) => (post._id === postId ? { ...post, comments: updatedPost.comments } : post))
        );
    
        setNewComment("");
        setPostIdForComment(null);
      } catch (error) {
        console.error("Erreur dans handleAddComment:", error.message);
      }
    };

    

    const handleDeletePost = async (id) => {
      try {
        const response = await fetch(`${API_URL}/api/posts/${id}`, { method: "DELETE" });
        if (!response.ok) throw new Error("Erreur lors de la suppression du post");
        setPosts(posts.filter((post) => post._id !== id)); 
        setActiveMenu(null);
      } catch (error) {
        console.error("Erreur dans handleDeletePost:", error.message);
      }
    };

    return (
      <div className="min-h-screen bg-gray-100 font-sans">
        <header className="bg-blue-600 text-white py-4 shadow-md">
          <div className="container mx-auto flex items-center px-6">
            <h1 className="text-2xl font-bold">
              <Link to="/dashboard" className="text-white hover:text-gray-300">lii</Link>
            </h1>
          </div>
        </header>
    
        <div className="flex flex-col items-center">
          <div className="bg-white shadow-md rounded-md mt-6 p-6 text-center w-4/5 max-w-3xl">
            <img
              className="w-24 h-24 mx-auto rounded-full border-4 border-blue-500 mb-4"
              src={generateAvatarUrl(`${user.firstName} ${user.lastName}`)}
              alt="User Avatar"
            />
            <h1 className="text-3xl font-semibold text-gray-800">{user.firstName} {user.lastName}</h1>
          </div>
    
          <div className="bg-white mt-6 shadow-md flex justify-center space-x-6 py-4 rounded-md w-4/5 max-w-3xl">
            {["Mur perso", "photos", "À propos de moi"].map((tab) => (
              <button
                key={tab}
                className={`px-6 py-2 font-medium ${activeTab === tab ? "border-b-4 border-blue-600 text-blue-600" : "text-gray-600 hover:text-blue-600"}`}
                onClick={() => setActiveTab(tab)}
              >
                {tab === "Mur perso" && <FaUserFriends className="inline mr-2" />}
                {tab === "photos" && <FaImages className="inline mr-2" />}
                {tab === "À propos de moi" && <FaInfoCircle className="inline mr-2" />}
                {tab.charAt(0).toUpperCase() + tab.slice(1)}
              </button>
            ))}
          </div>
    
          <div className="w-4/5 max-w-3xl">
            {activeTab === "Mur perso" && (
              <>
                {/* Ajout de post */}
                <div className="bg-white p-6 rounded-md shadow-md mb-6">
                  <textarea
                    value={newPost}
                    onChange={(e) => setNewPost(e.target.value)}
                    className="w-full h-24 p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 resize-none"
                    placeholder="Écrivez quelque chose..."
                  />
                  <button
                    onClick={handlePost}
                    className="mt-4 px-6 py-2 bg-blue-600 text-white rounded-md shadow-md hover:bg-blue-700 flex items-center justify-center gap-2 w-full"
                  >
                    <FaPaperPlane /> Ajouter un poste
                  </button>
                </div>
    
                {/* Affichage des posts */}
                {posts.length > 0 ? (
                  posts.map((post) => (
                    <div key={post?._id || Math.random()} className="bg-white p-6 rounded-md shadow-md mb-6 relative">
                      <div className="absolute top-2 right-2">
                        <button
                          onClick={() => setActiveMenu(activeMenu === post._id ? null : post._id)}
                          className="text-gray-400 hover:text-gray-600 focus:outline-none"
                          title="Menu"
                        >
                          &#x2026;
                        </button>
                        {activeMenu === post._id && (
                          <div className="absolute top-8 right-0 bg-white border shadow rounded z-10">
                            <ul>
                              <li
                                onClick={() => handleDeletePost(post._id)}
                                className="px-4 py-2 text-sm text-red-600 hover:bg-gray-100 cursor-pointer"
                              >
Supprimer poste                              </li>
                            </ul>
                          </div>
                        )}
                      </div>
    
                      <div className="flex items-center mb-4">
                        <img
                          className="w-12 h-12 rounded-full"
                          src={generateAvatarUrl(`${user.firstName} ${user.lastName}`)}
                          alt="User Avatar"
                        />
                        <div className="ml-4">
                          <h3 className="font-bold text-gray-800">{user.firstName}</h3>
                          <p className="text-sm text-gray-400">
                            {post?.createdAt ? new Date(post.createdAt).toLocaleString() : "Date inconnue"}
                          </p>
                        </div>
                      </div>
    
                      <p className="text-gray-600 mb-4">{post?.text || post?.content || "No content available"}</p>
    
                      <div className="flex justify-center gap-8">
                        <button
                          onClick={() => handleLikePost(post._id)}
                          className="flex items-center gap-2 text-gray-600 hover:text-blue-600"
                        >
                          <FaThumbsUp /> Like {post?.likes || 0}
                        </button>
                        <button
                          onClick={() => setPostIdForComment(post._id)}
                          className="flex items-center gap-2 text-gray-600 hover:text-blue-600"
                        >
                          <FaCommentAlt /> Comment
                        </button>
                      </div>
    
                      {/* Zone pour écrire un commentaire */}
                      {postIdForComment === post._id && (
                        <div className="mt-4">
                          <textarea
                            value={newComment}
                            onChange={(e) => setNewComment(e.target.value)}
                            className="w-full p-2 border rounded mb-2"
                            placeholder="Add a comment..."
                          />
                          <button
                            onClick={() => handleAddComment(post._id)}
                            className="bg-green-600 text-white px-6 py-2 rounded hover:bg-green-700"
                          >
                            Add Comment
                          </button>
                        </div>
                      )}
    
                      {/* Affichage des commentaires */}
                      <div className="mt-4">
                        {post.comments?.map((comment) => (
                          <div key={comment._id} className="relative flex justify-between items-center mb-2 p-2 bg-gray-100 rounded">
                            <p className="text-gray-600 text-sm">
                              💬 {comment.text}{" "}
                              <span className="text-sm text-gray-400">
                                —{" "}
                                {comment.author?._id === user?._id
                                  ? "You"
                                  : `${comment.author?.firstName || "Unknown"} ${comment.author?.lastName || ""}`}
                              </span>
                            </p>
    
                            {/* Menu suppression commentaire */}
                            {comment.author?._id === user?._id && (
                              <div className="relative">
                                <button
                                  onClick={() => setActiveCommentMenu(activeCommentMenu === comment._id ? null : comment._id)}
                                  className="text-gray-400 hover:text-gray-600 focus:outline-none"
                                  title="Options"
                                >
                                  &#x2026;
                                </button>
                                {activeCommentMenu === comment._id && (
                                  <div className="absolute top-6 right-0 bg-white border shadow rounded z-50">
                                    <ul>
                                      <li
                                        onClick={() => handleDeleteComment(post._id, comment._id)}
                                        className="px-4 py-2 text-sm text-red-600 hover:bg-gray-100 cursor-pointer"
                                      >
                                        Delete Comment
                                      </li>
                                    </ul>
                                  </div>
                                )}
                              </div>
                            )}
                          </div>
                        ))}
                      </div>
                    </div>
                  ))
                ) : (
                  <p className="text-gray-600 text-center">Rien encore ici...</p>
                )}
              </>
            )}
            {activeTab === "photos" && <Photos />}
            {activeTab === "À propos de moi" && <About user={user} />}                   </div>
        </div>
      </div>
    )};

  export default Profile;
